import { render } from "./cp_addMark.vue?vue&type=template&id=02c706d4&scoped=true"
import script from "./cp_addMark.vue?vue&type=script&lang=js"
export * from "./cp_addMark.vue?vue&type=script&lang=js"

import "./cp_addMark.vue?vue&type=style&index=0&id=02c706d4&scoped=scoped&lang=less"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c706d4"]])

export default __exports__